export default () => {
    return {
        menuOpen: false,
        activeMegaMenu: '',
        close() {
            this.activeMegaMenu = '';
        },
        isMegaMenuOpen(key = null) {
            if (key === null) {
                return this.activeMegaMenu !== '';
            }

            return this.activeMegaMenu === key;
        },
        toggleMegaMenu(key) {
            if (this.isMegaMenuOpen(key)) {
                this.close();
                return;
            }

            if (this.isMegaMenuOpen()) {
                this.close();

                setTimeout(() => {
                    this.activeMegaMenu = key;
                }, 150);
            } else {
                this.activeMegaMenu = key;
            }
        }
    };
}
